import { useState, useEffect } from 'react'
import { getNotificationByProfessionalId } from '../services/notifications'
import { INITIAL_SKIP } from '../pages/Professionals/Notifications/constants'

export const useGetNotifications = ({ LIMIT = 5 }) => {
  const { professional } = JSON.parse(localStorage.getItem('userData'))
  const [notifications, setNotifications] = useState([])
  const [totalNotifications, setTotalNotifications] = useState()
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    handleGetNotificationByProfessionalId({ skip: INITIAL_SKIP, limit: LIMIT })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleGetNotificationByProfessionalId = async (payLoad) => {
    try {
      setLoading(true)
      payLoad.id = professional.id
      const req = await getNotificationByProfessionalId(payLoad)
      setNotifications([...notifications, ...req?.list])
      setTotalNotifications(req.total)
      setLoading(false)
    } catch (error) {
    }
  }

  return {
    handleGetNotificationByProfessionalId,
    notifications,
    totalNotifications,
    loading
  }
}
